'use client';

import { useT } from '../i18n.client';
import type { LanguageCode } from '../i18n-resources/languages';

export function useCurrentLanguage(): LanguageCode {
    const { i18n } = useT();
    return i18n.language as LanguageCode;
}
